import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';

domReady(function () {
  const headerSwiper = document.querySelector('.header-block__swiper');

  if (headerSwiper) {
    new Swiper(headerSwiper, {
      draggable: true,
      navigation: {
        nextEl: '.header-block .swiper-navigation .swiper-button-next',
        prevEl: '.header-block .swiper-navigation .swiper-button-prev',
      },
    });
  }
});
